(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation_fixed"] && !Shopify.designMode) return;
  try {
    
  // var headerHeight = parseInt(getComputedStyle($one('.header')).height) 
  // try {
  //   headerHeight += (parseInt(getComputedStyle($one('.shopify-section--announcement-bar')).height) || 0) -1;
  // } catch (error) {
    
  // }

  const styles = getComputedStyle(document.querySelector('html'));
  var headerHeight = (parseInt(styles.getPropertyValue('--announcement-bar-height')) || 0) + (parseInt(styles.getPropertyValue('--header-height')) || 0);

  $one('.navigation_fixed').style.top = headerHeight + 'px';
  var html = "";
  $$('[navigation-title]').forEach(function(element){
    var title = element.getAttribute('navigation-title');
    if(title){
      html += "<span>"+title+"</span>";
    }
  });
  if(html){
    $one('.navigation_fixed .q_pageBox-box').innerHTML = html;
    $one('.navigation_fixed').classList.add('active');
  }

  $$('.q_pageBox-box > span').forEach(function(element, index){
    element.addEventListener('click', function(event){
      const styles = getComputedStyle(document.querySelector('html'));
      var headerHeight = (parseInt(styles.getPropertyValue('--announcement-bar-height')) || 0) + (parseInt(styles.getPropertyValue('--header-height')) || 0);

      var top = getTopDistance($$('[navigation-title]')[index]) - parseInt(getComputedStyle($one('.navigation_fixed')).height) - headerHeight;
      $$('.q_pageBox-box > span').forEach(function(el, ii){
        el.classList.remove('active');
      });
      element.classList.add('active');
      window.scrollTo(0, top);
    });
  });

  var pageHeight = document.documentElement.scrollHeight;
  var viewportHeight = window.innerHeight;
  window.addEventListener('scroll', () => {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    for (var i = $$('[navigation-title]').length - 1; i >= 0; i--) {
        if (scrollTop > getTopDistance($$('[navigation-title]')[i]) - parseInt(getComputedStyle($one('.navigation_fixed')).height) - headerHeight - 2) {
            $$('.q_pageBox-box > span').forEach(function(el, ii){
              el.classList.remove('active');
            });
            $$('.q_pageBox-box > span')[i].classList.add('active');
            return false
        }
    }
  });

  function  getTopDistance(element) {
      var top = element.getBoundingClientRect().top;
      return Math.round(top + window.scrollY);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-navigation"] && !Shopify.designMode) return;
  try {
    
  var navList = Array.prototype.filter.call(
    $$('[navigation-title]'),
    function (el) {
      var title = el.getAttribute('navigation-title');
      return title && title.trim();
    }
  );

  var headerHeight = parseInt(getComputedStyle($one('.header')).height) - 1;
  var html = '';
  navList.forEach(function (element) {
    var title = element.getAttribute('navigation-title');
    if (title) {
      html += '<span>' + title + '</span>';
    }
  });
  if (html) {
    $one('.product_navigation_fixed .q_pageBox-box').innerHTML = html;
    $one('.product_navigation_fixed').classList.add('active');
    // announcementBar = $one('.shopify-section--announcement-bar');
    // if(announcementBar){
    //   headerHeight += parseInt(getComputedStyle(announcementBar).height);
    //   $one('.product_navigation_fixed').style.setProperty('--header-height', headerHeight + 'px');
    // }
  }

  $$('.q_pageBox-box > span').forEach(function (element, index) {
    element.addEventListener('click', function (event) {
      var top =
        window.pageYOffset +
        navList[index].getBoundingClientRect().top -
        parseInt(getComputedStyle($one('.product_navigation_fixed span')).height) -
        headerHeight;
      $$('.q_pageBox-box > span').forEach(function (el, ii) {
        el.classList.remove('active');
      });
      element.classList.add('active');
      window.scrollTo(0, top);
    });
  });

  const pageHeight = document.documentElement.scrollHeight;
  const viewportHeight = window.innerHeight;
  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    /*
    if (scrollTop >= viewportHeight) {
      $one('.product_navigation_fixed').classList.add('active');
    } else {
      $one('.product_navigation_fixed').classList.remove('active');
    }
    */

    for (var i = $$('[navigation-title]').length - 1; i >= 0; i--) {
      var top =
        window.pageYOffset +
        navList[index].getBoundingClientRect().top -
        parseInt(getComputedStyle($one('.product_navigation_fixed span')).height) -
        headerHeight -
        2;
      if (scrollTop > top) {
        $$('.q_pageBox-box > span').forEach(function (el, ii) {
          el.classList.remove('active');
        });
        $$('.q_pageBox-box > span')[i].classList.add('active');
        //$('.q_pageBoxOvs').stop().animate({ scrollLeft: $('.q_pageBox-box > span')[i].position().left - $(window).width() * .2 }, 100);
        return false;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-list"] && !Shopify.designMode) return;
  try {
    
  class NavList extends HTMLElement {
    constructor() {
      super();
      this.tabItems = this.querySelectorAll('span');
      this.targetElements = new Map();
      this.init();
    }

    init() {
      // 预先获取所有目标元素并存储
      this.tabItems.forEach((tab, index) => {
        const selector = tab.dataset.target;
        if (selector) {
          const elements = document.querySelectorAll(selector);
          this.targetElements.set(tab, elements);

          // 隐藏除第一个选项卡外的所有内容
          if (index !== 0 && elements.length > 0) {
            elements.forEach((el) => el.setAttribute('hidden', ''));
          }
        }

        // 使用事件委托
        tab.addEventListener('click', this.handleTabClick.bind(this));
      });
    }

    handleTabClick(event) {
      const clickedTab = event.currentTarget;
      this.setActiveTab(clickedTab);
    }

    setActiveTab(activeTab) {
      this.tabItems.forEach((tab) => {
        const elements = this.targetElements.get(tab);

        if (tab === activeTab) {
          tab.classList.add('active');
          if (elements) {
            elements.forEach((el) => el.removeAttribute('hidden'));
          }
        } else {
          tab.classList.remove('active');
          if (elements) {
            elements.forEach((el) => el.setAttribute('hidden', ''));
          }
        }
      });
    }
  }

  if (!customElements.get('tab-list')) {
    customElements.define('tab-list', NavList);
  }

  /**
   * 吸顶 tab 条
   *
   * 注意：这个 section 只包含「标题 + tab 条」，被切换的内容是其它 section（block 里的 CSS 选择器指向别处），
   * 所以 section 本身很矮。用 position: sticky 的话，吸顶范围被限制在这个矮 section 内，滚两下就脱开了，
   * 因此这里改成：滚动到 header 下方时切到 position: fixed，并用外层 .tab-sticky-holder 撑住原来的高度，避免页面跳动。
   */
  class TabSticky extends HTMLElement {
    connectedCallback() {
      if (this.dataset.sticky !== 'true' || this.dataset.stickyReady === 'true') return;
      this.dataset.stickyReady = 'true';

      this.stuck = false;
      this.raf = null;
      this.holder = this.closest('.tab-sticky-holder') || this.parentElement;

      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.update();
        });
      };

      // 只在窗口尺寸变化时重新测量，避免滚动时每帧都写 CSS 变量
      this.onResize = () => {
        if (this.stuck) this.measure();
        this.onScroll();
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.raf) cancelAnimationFrame(this.raf);
      this.classList.remove('is-stuck');
      if (this.holder) this.holder.style.height = '';
      delete this.dataset.stickyReady;
    }

    /** 吸顶偏移量 = 吸顶公告栏高度 + 吸顶 header 高度（header 隐藏时为 0） */
    stickyOffset() {
      const styles = getComputedStyle(document.documentElement);
      const num = (name, fallback = 0) => {
        const value = parseFloat(styles.getPropertyValue(name));
        return isNaN(value) ? fallback : value;
      };

      const visible = num('--header-is-visible', 1);
      const area =
        num('--sticky-announcement-bar-enabled') * num('--announcement-bar-height') +
        num('--sticky-header-enabled') * num('--header-height');

      return visible * area;
    }

    update() {
      if (!this.isConnected || !this.holder) return;

      const shouldStick = this.holder.getBoundingClientRect().top <= this.stickyOffset();

      if (shouldStick && !this.stuck) {
        this.stick();
      } else if (!shouldStick && this.stuck) {
        this.unstick();
      }
    }

    measure() {
      const rect = this.holder.getBoundingClientRect();
      this.style.setProperty('--tab-sticky-left', rect.left + 'px');
      this.style.setProperty('--tab-sticky-width', rect.width + 'px');
    }

    stick() {
      const height = this.offsetHeight;

      this.measure();
      this.classList.add('is-stuck');
      this.holder.style.height = height + 'px';
      this.stuck = true;
    }

    unstick() {
      this.classList.remove('is-stuck');
      this.holder.style.height = '';
      this.stuck = false;
    }
  }

  if (!customElements.get('tab-sticky')) {
    customElements.define('tab-sticky', TabSticky);
  }

  } catch(e) { console.error(e); }
})();
})();
